import {
  ActionValidation,
  BooleanValidation,
  StringValidation,
} from '../../../utils/component-validations';
import { ensureSafeComponent } from '@embroider/util';
import { fn, hash } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import ModalCta from './shared/footer-cta.gjs';
import StandardModal from './standard.gjs';
import Super from '../core/base.gjs';

export default class SpdsModalDestructive extends Super {
  arguments = [
    new ActionValidation({
      optional: ['onBeforeClose', 'onOpen', 'primaryBtnAction', 'secondaryBtnAction'],
      required: ['onClose'],
    }),
    new BooleanValidation({
      optional: ['closeOnClickOutside', 'primaryBtnDisabled', 'secondaryBtnDisabled'],
    }),
    new StringValidation({ optional: ['primaryBtnText', 'secondaryBtnText', 'title'] }),
  ];
  baseClass = 'spds-modal-destructive';
  componentName = 'Spds::Modal::Destructive';

  @tracked footerComponent;

  get showStandardFooter() {
    let { primaryBtnAction, primaryBtnText, secondaryBtnAction, secondaryBtnText } = this.args;

    return (
      !this.footerComponent &&
      (primaryBtnAction || primaryBtnText || secondaryBtnAction || secondaryBtnText)
    );
  }

  <template>
    <StandardModal
      @closeOnClickOutside={{@closeOnClickOutside}}
      @onBeforeClose={{@onBeforeClose}}
      @onClose={{@onClose}}
      @onOpen={{@onOpen}}
      @variantName={{this.componentName}}
      class={{this.classes}}
      data-test-spds-modal-destructive
      {{this.validateArguments}}
      ...attributes
      as |M|
    >
      {{yield
        (hash
          Header=(ensureSafeComponent M.Header)
          Body=(ensureSafeComponent M.Body)
          Footer=(ensureSafeComponent
            M.Footer
            registerComponent=(fn this.registerComponent "footerComponent")
            unregisterComponent=(fn this.unregisterComponent "footerComponent")
          )
          beforeClose=M.beforeClose
          close=M.close
        )
      }}

      {{#if this.showStandardFooter}}
        <M.Footer>
          <ModalCta
            @close={{M.close}}
            @danger={{true}}
            @primaryBtnAction={{@primaryBtnAction}}
            @primaryBtnText={{@primaryBtnText}}
            @primaryBtnDisabled={{@primaryBtnDisabled}}
            @secondaryBtnAction={{@secondaryBtnAction}}
            @secondaryBtnText={{@secondaryBtnText}}
            @secondaryBtnDisabled={{@secondaryBtnDisabled}}
          />
        </M.Footer>
      {{/if}}
    </StandardModal>
  </template>
}
